// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2j6U-","title":"FrontImage_title__35AV0"};